import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { authApiGet } from '../../../services/authApi';
import {
  type LandingWaitlistListApiResponse,
  type LandingWaitlistListResponse,
  type LandingWaitlistFilters,
  mapLandingWaitlistListFromApi,
} from '../types/landingWaitlist.types';

const landingWaitlistKeys = {
  all: ['landing-waitlist'] as const,
  list: (filters: LandingWaitlistFilters) => ['landing-waitlist', 'list', filters] as const,
};

async function fetchLandingWaitlistEntries(
  filters: LandingWaitlistFilters
): Promise<LandingWaitlistListResponse> {
  const params: Record<string, string | number> = {};

  if (filters.search) {
    params.search = filters.search;
  }
  if (filters.page !== undefined) {
    params.offset = ((filters.page || 1) - 1) * (filters.limit || 50);
  }
  if (filters.limit) {
    params.limit = filters.limit;
  }
  if (filters.sortBy) {
    params.sort_by = filters.sortBy;
  }
  if (filters.sortOrder) {
    params.sort_order = filters.sortOrder;
  }

  const data = await authApiGet<LandingWaitlistListApiResponse>(
    '/api/admin/landing-waitlist',
    params
  );
  return mapLandingWaitlistListFromApi(data);
}

export function useLandingWaitlistEntries(
  filters: LandingWaitlistFilters
): UseQueryResult<LandingWaitlistListResponse, Error> {
  return useQuery({
    queryKey: landingWaitlistKeys.list(filters),
    queryFn: () => fetchLandingWaitlistEntries(filters),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
